import {useState, useEffect, useReducer} from 'react';
import axios from "axios";
import { useLocation } from 'react-router-dom';
import { usePageChange } from '../usePageChange';

const dataFetchReducer = (state, action) => {
    switch (action.type) {
        case 'FETCH_INIT':
            return {
                ...state,
                isLoading: true,
                isError: false,
                id: action.id
            };
        case 'FETCH_SUCCESS':
            return {
                ...state,
                isLoading: false,
                isError: false,
                data: action.payload,
            };
        case 'FETCH_FAILURE':
            return {
                ...state,
                isLoading: false,
                isError: true,
                data: action.payload
            };
        default:
            throw new Error();
    }
};
const baseApiEndpoint = process.env.REACT_APP_REST_ENDPOINT;
const baseApiAuthEndpoint = process.env.REACT_APP_REST_AUTH_ENDPOINT;
const baseApiSocialEndpoint = process.env.REACT_APP_SOCIAL_ENDPOINT;
const baseApiFinanceEndpoint = process.env.REACT_APP_FINANCE_ENDPOINT;

export const useDataFetch = (initialParams) => {
    const user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null;
    const token = user ? user.user?.tk : "";
    const { goToPage } = usePageChange();
    const { pathname } = useLocation();
    // const token = "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE2Mjg0NTQwMDcsImp0aSI6ImU5MGY4ODQzLThjOGEtNDNjZi1iYzY3LTE2Y2QzNDkxNmFkMyIsImlhdCI6MTYyNTg2MjAwNywic3ViIjoiNjY2NyIsInVzZXJfaWQiOjY2NjcsIm5hbWUiOiJ0ZXN0IHRlc3QiLCJtb2JpbGUiOiI5MzAyNjk4MjU1IiwiZW1haWwiOiJtYXlyYWJAbGtqLmNvbSIsImNvbXBhbnlfaWRzIjpbIjliNTUwY2M2LTYwZjAtNDVlZC1iOWI2LWNlMjQ5ZmNjNDE4ZCJdfQ.AwFZBTmev94d3NskasolXz8JtA0MxqrqDZhwyAdXyDsZsusR7uvI5eI7JJycbt9XFKLxPA7sJOUzRGGDyrNOPM9Zqyqyb-AmOIij142yuGz8aT7FC9NqN9tluFl0DPVOz1zeAOmdemjqaRAfn4ea7MD93U4QRxPV_lEc7I4dZnK-NWmcRI5wIt-fhBafv-1W7Tw6UeMOgEdaZEyk1ItcQr8JQgf-y4hOdaw0Pdga1-dNPZ5zpvHlTrgudhW4dD7xX1S1WuZmRJnwW1IuP_l7tBW6dtH8VCWg-m5ZHWjMCp9j79N89l8Hju99pv39DCc2kmD6jXhHU0w3NkEqo7qhfetmcYX3xi4Zh_rR8auAZ9_aYOlnhyBMRXjF8VxV_gXRXLJ-6-23Pi5G1xnXsaWC67VdcACfkHQGwjzXDPcavq0oQXIfvwJC97pg_N5dwx7h_9fFbRd2YxgfNGx4dK-Lxv-6cIhN2EoRYNg_5sHwD7l1Rlni6KQHeccgjE5knQgF33cO8n-sibeCD8AZaPLWH6AUK62i-Lr-vFyfjEKk5RKb_fPJODounKF_ILKSBaSZ4DbQAMiTRsA6KH-oHYLmmx0H3sUOWMSL1flaAJprwWS6HRaXEVH01s6Znugyldzp2NFuei6x3GWHYTeS-xfyCqQ4GxRPEt4Px8R_6H-ejFo"
    // const config = {
    //     headers: {
    //         'Authorization': `Bearer ${token}`
    //     }
    // };

    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    if(initialParams?.download) axios.defaults.headers.common['Content-Disposition'] = `attachment; filename=file.xlsx`;
    if(initialParams?.download) axios.defaults.headers.common['Content-Type'] = `application/vnd.openxmlformats-officedocument.spreadsheetml.sheet`;
    const [params, setParams] = useState(initialParams); // {method, url, data}
    const [state, dispatch] = useReducer(dataFetchReducer, {
        isLoading: false,
        isError: false,
        data: initialParams && initialParams.data,
        id: initialParams && initialParams.id,
        type: initialParams ? initialParams.type : 'dms'
    });

    const validRoutes = (route) =>{
        switch (route) {
            case 'login':
            case 'signup':
            case 'verify-code':
            case 'privacy-policy':
                    return false;
            default: return true;
        }
    }

    const getBaseRoute = (type) => {
        switch (type) {
            case 'social': return baseApiSocialEndpoint;
            case 'finance': return baseApiFinanceEndpoint;
            case 'auth': return baseApiAuthEndpoint;
            default: return baseApiEndpoint;
        }
    }

    useEffect(() => {
        if(params){
            const fetchData = async () => {
                dispatch({ type: 'FETCH_INIT', id: params.id });
                await axios({
                    method: params?.method?.toLowerCase(),
                    url: params?.rawUrl ? params.url : getBaseRoute(params?.type) + params.url,
                    data: params?.data,
                    responseType: params?.download ? 'blob' : 'json'
                })
                    .then(result => {
                        dispatch({ type: 'FETCH_SUCCESS', payload: result.data });
                    })
                    .catch(err => {
                        dispatch({ type: 'FETCH_FAILURE', payload: err});
                        if(err?.response?.status === 401 && params.type !== 'auth' && validRoutes() && process.env.REACT_APP_ENV !== "demo"){
                            localStorage.removeItem('user');
                            setTimeout(() => {
                                goToPage('/');
                            }, 1000);
                        }
                    });
            };

            fetchData();
        }
    }, [params]);

    return [state, setParams];
};
